import { render } from "./partnership-with-ndss.vue?vue&type=template&id=7eb0e4da&scoped=true"
import script from "./partnership-with-ndss.vue?vue&type=script&lang=js"
export * from "./partnership-with-ndss.vue?vue&type=script&lang=js"

import "./partnership-with-ndss.vue?vue&type=style&index=0&id=7eb0e4da&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb0e4da"]])

export default __exports__